import React from 'react';
import PropTypes from 'prop-types';
import { useDividerGradient } from '../gradient-utils';

export function WaveAsymmetric({
  className,
  amplitude = 50,
  fadeOpacity,
  fadeDirection,
  softness,
  style
}) {
  const { defs, fill, mask } = useDividerGradient({ fadeOpacity, fadeDirection, softness });

  const scale = amplitude / 50;
  const mid = 50;
  const y = base => mid + (base - mid) * scale;
  const minY = mid - 40 * scale;
  const viewHeight = 120 - minY;
  const viewBox = `0 ${minY} 1200 ${viewHeight}`;

  return (
    <svg
      className={ className }
      style={ style }
      viewBox={ viewBox }
      preserveAspectRatio='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      { defs }
      <path
        d={ `M0,${y(40)} C100,${y(80)} 250,${y(10)} 400,${y(50)} C550,${y(90)} 650,${y(30)} 800,${y(
          60
        )} C950,${y(90)} 1100,${y(20)} 1200,${y(50)} L1200,120 L0,120 Z` }
        fill={ fill }
        mask={ mask }
      />
    </svg>
  );
}

WaveAsymmetric.propTypes = {
  className: PropTypes.string,
  amplitude: PropTypes.number,
  fadeOpacity: PropTypes.number,
  fadeDirection: PropTypes.oneOf(['down', 'up', 'left', 'right']),
  softness: PropTypes.number
};
